import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src", "alt"]

import { ref } from 'vue'

interface Props {
  asLink?: boolean,
  images: string[],
  mainImageIdx?: number,
  loadingImage?: string | null,
  alt: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppImageLightBox',
  props: {
    asLink: { type: Boolean, default: false },
    images: { default: () => [] },
    mainImageIdx: { default: 0 },
    loadingImage: { default: null },
    alt: null
  },
  setup(__props: any) {

const props = __props as { asLink: boolean, images: string[], mainImageIdx: number, loadingImage: string | null, alt: string };

const defaultLoadingImage = require.context('@/assets/images', false, /\.jpeg/)('./square-placeholder.jpeg')



const visible = ref(false)

function onImageClick () {
  visible.value = true
}

function onHide () {
  visible.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_vue_easy_lightbox = _resolveComponent("vue-easy-lightbox")!

  return (_openBlock(), _createElementBlock("div", null, [
    (props.asLink)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: "#",
          onClick: onImageClick
        }, [
          _renderSlot(_ctx.$slots, "default", {}, () => [
            _createTextVNode("Gallery")
          ])
        ]))
      : (_openBlock(), _createElementBlock("img", {
          key: 1,
          src: props.images[props.mainImageIdx] || props.images[0] || props.loadingImage || _unref(defaultLoadingImage),
          alt: props.images[0],
          class: "img-thumbnail",
          onClick: onImageClick
        }, null, 8, _hoisted_1)),
    (props.images.length > 0)
      ? (_openBlock(), _createBlock(_component_vue_easy_lightbox, {
          key: 2,
          visible: visible.value,
          imgs: props.images,
          "move-disabled": "",
          "scroll-disabled": "",
          onHide: onHide
        }, null, 8, ["visible", "imgs"]))
      : _createCommentVNode("", true)
  ]))
}
}

})